import { createReducer } from '@reduxjs/toolkit';
import {
  GET_TRANSACTIONS,
  GET_TRANSACTIONSV2,
  GET_TRANSACTIONS_INFLATE,
  INIT_LIST_FORM,
  UPDATE_LIST_FORM,
  UPDATE_TRANSACTION,
} from '../actions/transactions';

type Pagination = {
  current: number;
  has_next: boolean;
  has_prev: boolean;
  max_page: number;
  per_page: number;
};

type Paginated<T> = {
  rows: T[];
  count: number;
  pagination?: Pagination;
};

type MoneyPoint = {
  money: number;
  point: number;
};

type Transaction = {
  id: string;
  amount: number;
  money_amount: number;
  point_amount: number;
  raw_point_amount: number;
  done_at: string;
  shop_name: string;
  shop_id: string;
  organization_name: string;
  terminal_id: string;
};

export type TransactionState = {
  transactions: Paginated<Transaction> & {
    summary: {
      topup: MoneyPoint;
      payment: MoneyPoint;
    };
  };
  transactionsV2: Paginated<Transaction> & {
    prev: string | null;
    next: string | null;
    per_page: number;
  };
  listForm: {
    from: string | null;
    to: string | null;
    transactionId: string;
    shopId: string;
    terminalId: string;
    customerId: string;
    customerName: string;
    organization: string;
    isModified: boolean;
    transactionTypes: string[];
    topupMethodTypes: string[];
    privateMoney: string;
    description: string;
  };
};

export const initialState: TransactionState = {
  transactions: {
    rows: [],
    count: 0,
    summary: {
      topup: {
        money: 0,
        point: 0,
      },
      payment: {
        money: 0,
        point: 0,
      },
    },
    pagination: {
      current: 1,
      has_next: false,
      has_prev: false,
      max_page: 1,
      per_page: 50,
    },
  },
  transactionsV2: {
    rows: [],
    count: 0,
    per_page: 50,
    prev: null,
    next: null,
  },
  listForm: {
    from: null,
    to: null,
    transactionId: '',
    shopId: '',
    terminalId: '',
    customerId: '',
    customerName: '',
    organization: '',
    isModified: false,
    transactionTypes: [],
    topupMethodTypes: [],
    privateMoney: '',
    description: '',
  },
};

const transactionReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(GET_TRANSACTIONS, (state, action) => {
      return { ...state, transactions: action.payload };
    })
    .addCase(GET_TRANSACTIONSV2, (state, action) => {
      return { ...state, transactionsV2: action.payload };
    })
    .addCase(GET_TRANSACTIONS_INFLATE, (state, action) => {
      const transactions = {
        count: state.transactions.count,
        summary: state.transactions.summary,
        rows: state.transactions.rows.concat(action.payload.rows),
        pagination: action.payload.pagination,
      };
      return { ...state, transactions };
    })
    .addCase(INIT_LIST_FORM, (state, action) => {
      return { ...state, listForm: { ...initialState.listForm, ...action.payload } };
    })
    .addCase(UPDATE_LIST_FORM, (state, action) => {
      return { ...state, listForm: { ...state.listForm, ...action.payload } };
    })
    .addCase(UPDATE_TRANSACTION, (state, action) => {
      const { transactions } = state;
      const { rows } = transactions;
      const index = rows.findIndex((row) => row.id === action.payload.id);
      if (index >= 0) {
        const item = rows[index];
        const target = action.payload;
        rows[index] = { ...item, ...target, amount: target.money_amount + target.point_amount };
      }
    })
);

export default transactionReducer;
